import * as $ from 'jquery';
import ViewportTracker from '../lib/ViewportTracker';
import StickyItem from './StickyItem';

import * as variables from '../variables.js';

ViewportTracker.init(variables);

export default class StickyItems {
	constructor() {
		if (!document.querySelector('.no-flexboxlegacy .productStats__nav')) { // Only needed in IE 11, which doesn't support position: sticky
			return;
		}

		/* Ensures the item sticks on load */
		if ( ViewportTracker.above('productStatsStack') ) {
			this.stickyContent.stick();
		}
		this.eventHandlerStateChange();
		window.addEventListener('resize', this.eventHandlerStateChangeCB);
	}

	/* Actual Sticky Items */
	private stickyContent: StickyItem = new StickyItem('.productStats__navInner', {
		adjustTop : 20,
		container : $('<div id="productStatsDrawer" />').appendTo('.productStats'),
		widthSizer : $('.productStats__nav')
	});

	/* Events */
	private eventHandlerStateChange: Function = function(): void {
		if ( ViewportTracker.above('productStatsStack') ) {
			this.stickyContent.bindEvents();
		} else {
			this.stickyContent.unbindEvents();
		}
	};
	private eventHandlerStateChangeCB: EventListener = (event: Event): void => {
		this.eventHandlerStateChange();
	};
}